import { useCallback, useEffect, useRef, useState } from "react";
import { Backdrop, CircularProgress, FormControl, FormControlLabel, Grid, Stack, Tab, Tabs, TextField, Box, Typography, Switch, FormGroup, Button } from "@mui/material";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Select from 'react-select';
import FormPageHeader from "../utilities/FormPageHeader";
import { checkPassword, emailValidation, checkString, comparePassword, checkBlankSpace, checkSpecialChar } from "../utilities/FormValidation";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import TimezoneSelect, { allTimezones } from "react-timezone-select";
import { countryToAlpha2 } from 'country-to-iso';
import * as Flags from 'country-flag-icons/react/3x2'
import customStyles from "app/shared-components/SelectCustomStyle";
import {
    buildSelectedShowrooms,
    getSelectedShowroomIds,
    getSelectedShowroomNames,
    hasSameShowroomIds,
} from "../utilities/showroomUtils";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { isIAMOnlyUser, canIAMManagePartner, IAM_PARTNER_ACCESS_MESSAGE } from "../utilities/iamTerritoryUtils";
import RequiredLabel from "../utilities/RequiredLabel";

const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const UserForm = () => {
    const [firstName, setFirstName] = useState();
    const [lastName, setLastName] = useState();
    const [middleName, setMiddleName] = useState();
    const [userName, setUserName] = useState();
    const [nickName, setNickName] = useState();
    const [password, setPassword] = useState();
    const [cpassword, setCPassword] = useState();
    const [selectedShowrooms, setSelectedShowrooms] = useState([]);
    const [email, setEmail] = useState();
    const [phoneNumber, setPhoneNumber] = useState();
    const [role, setRole] = useState([]);
    const [gender, setGender] = useState();
    const [birthDate, setBirthDate] = useState();
    const [designation, setDesignation] = useState();
    const [timezone, setTimeZone] = useState(defaultTimezone);
    const [country, setCountry] = useState();
    const [partner, setPartner] = useState();
    const [partnerId, setPartnerId] = useState();
    const [active, setActive] = useState(true);
    const [snackState, setSnackState] = useState(false);
    const [editData, setEditData] = useState();
    const [profileImage, setProfileImage] = useState();
    const [profileImageUrl, setProfileImageUrl] = useState();
    const [imgFile, setImgFile] = useState();
    const [successMsg, setSuccessMsg] = useState();
    const [checkStatus, setCheckStatus] = useState(true);
    const [hideDelete, setHideDelete] = useState(true)
    const [saving, setSaving] = useState(false);
    const savingRef = useRef(false);

    const formRef = useRef(null);
    const params = useParams();
    const [loading, setLoading] = useState(Boolean(params.id));
    const navigate = useNavigate();
    const userList = JSON.parse(localStorage.getItem('userList'));
    const [tabValue, setTabValue] = useState(0);
    const [error, setError] = useState();
    const [countryOptions, setCountryOptions] = useState();
    const [roleOptions, setRoleOptions] = useState();
    const [showroomOptions, setShowroomOptions] = useState();
    const [companyOptions, setCompanyOptions] = useState();
    const [validError, setValidError] = useState({});
    const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;
    const userUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.user}`;
    const [checksubmit, setCheckSubmit] = useState(false);
    const queryParam = new URLSearchParams(window.location.search);
    const fileInputRef = useRef(null);

    const submitUser = async () => {
        setCheckSubmit(true)
        setSnackState(false);
        if (!(await canIAMManagePartner(params.id ? editData?.companyId : partnerId))) {
            setError(IAM_PARTNER_ACCESS_MESSAGE);
            return;
        }
        let model = {
            firstName: firstName,
            middleName: middleName,
            lastName: lastName,
            userName: userName,
            // nickName: nickName,
            // gender: gender,
            birthDate: birthDate,
            timeZone: timezone?.value || '',
            email: email,
            phoneNumber: phoneNumber,
            roles: role,
            companyName: partner,
            companyId: partnerId,
            showroomName: getSelectedShowroomNames(selectedShowrooms),
            showroomId: getSelectedShowroomIds(selectedShowrooms),
            profileImage:profileImage,
            password: password,
            active: active,
            // confirmPassword: cpassword,
            country: country,
            designation
        };

        try {
            if (imgFile) {
                const formData = new FormData();
                formData.append("image", imgFile);
                await OAuthService.uploadFile(userUrl + '/image/upload', formData)
            }
            if (params.id) {
                if (firstName && lastName && userName && email && role && country && !validError.firstName
                    && !validError.middleName && !validError.lastName && !validError.userName && !validError.email &&
                    !validError.role && !validError.country) {
                    await OAuthService.updateData(url, params.id, model);
                    setSuccessMsg("Data Updated Successfully")
                    setSnackState(true);
                    await new Promise((resolve) => setTimeout(resolve, 800));
                    navigate('/users');
                }
            } else {
                if (firstName && lastName && userName && email && password && cpassword && role && country && !validError.firstName
                    && !validError.middleName && !validError.lastName && !validError.userName && !validError.email && !validError.password && !validError.cpassword &&
                    !validError.role && !validError.country) {
                    await OAuthService.addData(url, model);
                    setSuccessMsg("Data saved Successfully")
                    setSnackState(true);
                    if (queryParam.get('customerId')) {
                        await new Promise((resolve) => setTimeout(resolve, 800));
                        navigate('/editPartner/' + queryParam.get('customerId') + '?tab=4');
                    } else if (queryParam.get('showroomId')) {
                        await new Promise((resolve) => setTimeout(resolve, 800));
                        navigate('/editShowroom/' + queryParam.get('showroomId') + '?tab=1');
                    } else {
                        await new Promise((resolve) => setTimeout(resolve, 800));
                        navigate(isIAMOnlyUser() ? iamReturnPath : '/users');
                    }
                }
            }

        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
            return;
        }

    }
    const runSaving = async (task) => {
      if (savingRef.current) return;
      savingRef.current = true;
      setSaving(true);
      try {
        return await task();
      } finally {
        savingRef.current = false;
        setSaving(false);
      }
    };

    const handleSubmit = () => runSaving(submitUser);

    const editUser = async () => {
        try {
            const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}/search/findByUserId?userId=${params.id}`;
            const result = await OAuthService.getList(url);
            const user = result?.data;

            if (user.country) {
                let code = countryToAlpha2(user.country)
                const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.company}/companiesByCntyCode?countryCode=${code}&size=1000`;
                const companies = await OAuthService.getList(url);
                const result = companies?.data?.result.map((value) => {
                    return { label: value.text, value: value.text, id: value.id }
                })

                setCompanyOptions(result);
            }

            let loadedShowroomOptions = [];
            if (user.companyId) {
                const apiurl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.showroom}/showroomsByCompanyNum?companyNum=${user.companyId}&size=100`;
                const showrooms = await OAuthService.getList(apiurl);
                const showroomresult = showrooms?.data?.result?.map((value) => {
                    return { label: value.text, value: value.text, id: value.id }
                })
                loadedShowroomOptions = showroomresult || [];
                setShowroomOptions(showroomresult);
            }
            user.timeZone && setTimeZone(user.timeZone);

            setFirstName(user.firstName);
            setLastName(user.lastName);
            setMiddleName(user.middleName);
            setUserName(user.userName);
            setNickName(user.nickName);
            setEmail(user.email);
            setPhoneNumber(user.phoneNumber);
            setRole(user.roles);
            setGender(user.gender);
            setBirthDate(user.birthDate);
            setActive(user.active);
            setPartner(user.companyName);
            setCountry(user.country);
            setSelectedShowrooms(buildSelectedShowrooms(user.showroomId, loadedShowroomOptions, user.showroomName));
            setProfileImage(user.profileImage);
            setPassword(user.password);
            setEditData(user);
            if (user.profileImage) {
                const response = await OAuthService.getDownload(userUrl + `/image/download/${user.profileImage}`);
                const imgURL = URL.createObjectURL(response.data)
                setProfileImageUrl(imgURL)
            }
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
        } finally {
            setLoading(false);
        }
    }
    const handlePartnerChange = async (data) => {
        setPartner(data.value);
        setPartnerId(data.id);
        setSelectedShowrooms([]);
        const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.showroom}/showroomsByCompanyNum?companyNum=${data.id}&size=100`;
        const showrooms = await OAuthService.getList(url);
        const result = showrooms?.data?.result?.map((value) => {
            return { label: value.text, value: value.text, id: value.id }
        })

        setShowroomOptions(result)
    }
    const handleShowroomChange = (data) => {
        setSelectedShowrooms(data || []);
    }
    const handleActiveChange = (e) => {
        setActive(e.target.checked);
    };
    useEffect(() => {
        if (params.id) {
            editUser();
            setHideDelete(false)
        }
    }, [])

    const handleChangeUploadProfile = (e) => {
        const file = e.target.files[0];
        setImgFile(file)
        const imgURL = URL.createObjectURL(file)
        setProfileImageUrl(imgURL)
        setProfileImage(file.name)
    }

    const removeDocument = () => {
        setProfileImageUrl('')
        setProfileImage(null)
        setImgFile('')
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    }

    useEffect(() => {
        if (queryParam.get('showroomId')) {
            const showroom = async () => {
                const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.showrooms}`;


                const result = await OAuthService.getEditData(url, queryParam.get('showroomId'));
                const showroom = result.data;
                if (showroom) {
                    const getCompany = await OAuthService.getEditData(`${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`, showroom?.parentCompanyNumber);
                    setCountry(getCompany.data?.countryName)
                    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.company}/companiesByCntyCode?countryCode=${getCompany.data?.countryCode}&size=100`;
                    const companies = await OAuthService.getList(url);
                    const companyresult = companies?.data?.result?.map((value) => {
                        return { label: value.text, value: value.text, id: value.id }
                    })

                    setCompanyOptions(companyresult);
                    setPartner(showroom?.parentCompanyName)
                    setPartnerId(showroom?.parentCompanyNumber)

                    if (companies) {
                        const showurl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.showroom}/showroomsByCompanyNum?companyNum=${showroom?.parentCompanyNumber}&size=1000`;
                        const showrooms = await OAuthService.getList(showurl);
                        const showroomresult = showrooms?.data?.result?.map((value) => {
                            return { label: value.text, value: value.text, id: value.id }
                        })

                        setShowroomOptions(showroomresult)

                        setSelectedShowrooms(buildSelectedShowrooms([queryParam.get('showroomId')], showroomresult, showroom?.name));
                    }
                }

            }
            showroom()
        }
    }, [queryParam.get('showroomId')]);
    useEffect(() => {
        if (queryParam.get('customerId')) {
            const companies = async () => {
                const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;


                const result = await OAuthService.getEditData(url, queryParam.get('customerId'));
                const company = result.data;
                if (company) {
                    setCountry(company?.countryName);
                    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.company}/companiesByCntyCode?countryCode=${company?.countryCode}&size=1000`;
                    const companies = await OAuthService.getList(url);
                    const companyresult = companies?.data?.result?.map((value) => {
                        return { label: value.text, value: value.text, id: value.id }
                    })

                    setCompanyOptions(companyresult);
                    setPartner(company?.name);
                    setPartnerId(queryParam.get('customerId'));

                    const showurl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.showroom}/showroomsByCompanyNum?companyNum=${queryParam.get('customerId')}&size=100`;
                    const showrooms = await OAuthService.getList(showurl);
                    const showroomresult = showrooms?.data?.result?.map((value) => {
                        return { label: value.text, value: value.text, id: value.id }
                    })

                    setShowroomOptions(showroomresult)
                }
            }
            companies()
        }
    }, [queryParam.get('customerId')]);
    /**
   * Tab Change
   */
    const handleTabChange = (event, value) => {
        setTabValue(value);
    }

  useEffect(() => {
    if (params?.id) {
      if (
        firstName &&
        lastName &&
        userName &&
        role.length > 0 &&
        email &&
        country &&
        partner
      ) {
        if (editData) {
          if (
            firstName !== editData.firstName ||
            lastName !== editData.lastName ||
            middleName !== editData.middleName ||
            userName !== editData.userName ||
            JSON.stringify(role) !== JSON.stringify(editData.roles) ||
            email !== editData.email ||
            country !== editData.country ||
            partner !== editData.companyName ||
            typeof birthDate !== typeof editData.birthDate ||
            active !== editData.active ||
            !hasSameShowroomIds(selectedShowrooms, editData.showroomId) ||
            timezone !== (editData.timeZone || defaultTimezone) ||
            profileImage !== editData.profileImage
          ) {
            setCheckStatus(false);
          } else {
            setCheckStatus(true);
          }
        } else {
          setCheckStatus(false);
        }
      } else {
        setCheckStatus(true);
      }
    } else {
      if (
        firstName &&
        lastName &&
        userName &&
        role.length > 0 &&
        email &&
        password &&
        cpassword &&
        country &&
        partner
      ) {
        setCheckStatus(false);
      } else {
        setCheckStatus(true);
      }
    }
  }, [
    firstName,
    lastName,
    userName,
    middleName,
    role,
    email,
    password,
    cpassword,
    country,
    partner,
    birthDate,
    active,
    selectedShowrooms,
    timezone,
    profileImage
  ]);

    const deleteUser = async () => {
        try {
            if (params.id) {
                await OAuthService.deleteData(url, params.id);
            }

        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message);
            return;
        }
        navigate('/users');
    }

    const handleDelete = () => runSaving(deleteUser);

    const handleRoleChange = (value) => {
        const roles = value.map((row) => {
            return row.value
        });
        setRole(roles);
    }
    const checkUniqueEmail = async (email) => {
        if (!params.id) {
            const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}/search/findByEmail?email=${email}`;
            const result = await OAuthService.getList(url);
            if (result.data) {
                setValidError({ ...validError, email: "This email is already exist" })
            }
        }
    }
    const checkUniqueUserName = async (name) => {
        if (!params.id) {
            const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}/search/findByUserName?userName=${name}`;
            const result = await OAuthService.getList(url);
            if (result.data) {
                setValidError({ ...validError, userName: "This username is already exist" })
            }
        }
    }

    const handleCountryChange = async (data) => {
        setCountry(data.value);
        const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.company}/companiesByCntyCode?countryCode=${data.code}&size=1000`;
        const companies = await OAuthService.getList(url);
        const result = companies?.data?.result.map((value) => {
            return { label: value.text, value: value.text, id: value.id }
        })

        setCompanyOptions(result);
    };

    useEffect(() => {
        const country = async () => {
            const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.country}?size=1000`;
            const countries = await OAuthService.getList(url);

            const result = countries?.data?._embedded.countries.map((value) => {
                const Flag = Flags[value.isoCode];
                return { label: value.name, value: value.name, code: value.isoCode, icon: value.isoCode && <Flag width={18} style={{ marginInline: "5px" }} /> }
            })
            setCountryOptions(result);
        }
        const role = async () => {
            const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.role}?size=1000`;
            const roles = await OAuthService.getList(url);
            let result = roles?.data?._embedded.roles.map((value) => {
                return { label: value?._links?.role.href.split('/').pop(), value: value?._links?.role.href.split('/').pop(), id: value?._links?.role.href.split('/').pop() }
            })
            if(isIAMOnlyUser()){
                result = result.filter((value) => value?.label === 'ROLE_PARTNER_ADMIN' || value?.label === 'ROLE_PARTNRORDPROCESS' || value?.label === 'ROLE_SHWRMMGR');
            } else if(queryParam.get('customerId')){
                result = result.filter((value) => {
                    if(value?.label === 'ROLE_PARTNER' || value?.label === 'ROLE_PARTNER_ADMIN' || value?.label === 'ROLE_SHWRMMGR'){
                        return { label: value?.label, value: value?.label, id: value?.label }
                    }
                })
            }
            setRoleOptions(result);
        }
        country();
        role();
    }, [])

    const handleTimeZone = (e) => {
        setTimeZone(e)
    }

    const iamReturnPath = queryParam.get('customerId')
        ? '/editPartner/' + queryParam.get('customerId') + '?tab=4'
        : queryParam.get('showroomId')
            ? '/editShowroom/' + queryParam.get('showroomId') + '?tab=1'
            : '/dashboard';
    const iamReturnName = queryParam.get('customerId') ? 'Partner' : queryParam.get('showroomId') ? 'Showroom' : null;

    const handleCancel = () => {
        navigate(isIAMOnlyUser() ? iamReturnPath : '/users')
    }

    useEffect(() => {
        if (params?.id) {
            if (firstName && lastName &&  userName && role.length > 0 && email && country && partner && Object.values(validError).filter(o => o !== null && o !== "" && o !== undefined).length === 0) {
                if (editData) {
                    if (firstName !== editData.firstName || lastName !== editData.lastName || middleName !== editData.middleName || userName !== editData.userName
                        || JSON.stringify(role) !== JSON.stringify(editData.roles) || email !== editData.email || country !== editData.country || partner !== editData.companyName
                        || typeof (birthDate) !== typeof (editData.birthDate) || active !== editData.active || !hasSameShowroomIds(selectedShowrooms, editData.showroomId) || timezone !== (editData.timeZone || defaultTimezone)) {
                        setCheckStatus(false)
                    } else {
                        setCheckStatus(true)
                    }
                } else {
                    setCheckStatus(false)
                }
            } else {
                setCheckStatus(true)
            }
        } else {
            if (firstName && lastName  && userName && role.length > 0 && email && password && cpassword && country && partner && Object.values(validError).filter(o => o !== null && o !== "" && o !== undefined).length === 0) {
                setCheckStatus(false)
            } else {
                setCheckStatus(true)
            }
        }
    }, [firstName, lastName, userName, middleName, role, email, password, cpassword, country, partner, birthDate, active, selectedShowrooms, timezone, validError]);


    return (
        <div className="w-full overflow-scroll">
            <Backdrop
                open={loading || saving}
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <FormPageHeader
                componentName="User"
                // handleDelete={handleDelete}
                handleSubmit={handleSubmit}
                saveDisable={checkStatus}
                breadCrumbSeperator=">"
                currentPage={params.id ? "Update User" : "Add User"}
                parentBreadcrumbData={
                    isIAMOnlyUser()
                        ? (iamReturnName ? [{ pageName: iamReturnName, pageLink: iamReturnPath }] : [])
                        : [{ pageName: 'User List', pageLink: '/users' }]
                }
                error={error}                
                successMsg={successMsg}
                snackState={snackState}
                hideDelete={hideDelete}
                handleCancel={handleCancel}
            >
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    indicatorColor="secondary"
                    textColor="inherit"
                    sx={{ color: 'yellow' }}
                    variant="scrollable"
                    scrollButtons="auto"
                    classes={{ root: 'w-full border-b-1' }}
                >
                    <Tab label="General" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
                </Tabs>
            </FormPageHeader>
            <div className="p-16 sm:p-24">
                <FormControl
                    ref={formRef}
                    className="flex flex-col justify-center"
                >
                    <div className={tabValue !== 0 ? 'hidden' : ''}>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Box spacing={2} className="mb-20 mt-20" sx={{ p: 2, border: '1px dashed grey' }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Stack>
                                                <RequiredLabel>First Name</RequiredLabel>
                                                <TextField
                                                    className="mb-16"
                                                    type="text"
                                                    error={(checksubmit && !firstName) || validError.firstName ? true : false}
                                                    name="firstName"
                                                    value={firstName}
                                                    onChange={(e) => { setFirstName(e.target.value.toUpperCase()); setValidError({ ...validError, firstName: checkString(e.target.value) || checkSpecialChar(e.target.value) }) }}
                                                    helperText={(checksubmit && !firstName) ? "This field is required" : validError.firstName}
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        shrink: firstName ? true : false,
                                                    }}
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Stack>
                                                <label>Middle Name</label>
                                                <TextField
                                                    className="mb-16"
                                                    error={(checksubmit && !middleName) || validError.middleName ? true : false}
                                                    type="text"
                                                    name="middleName"
                                                    value={middleName}
                                                    onChange={(e) => { setMiddleName(e.target.value.toUpperCase()); setValidError({ ...validError, middleName: checkString(e.target.value) || checkSpecialChar(e.target.value) }) }}
                                                    variant="outlined"
                                                    helperText={validError.middleName}
                                                    InputLabelProps={{
                                                        shrink: middleName ? true : false,
                                                    }}
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Stack>
                                                <RequiredLabel>Last Name</RequiredLabel>
                                                <TextField
                                                    className="mb-16"
                                                    type="text"
                                                    name="lastName"
                                                    error={(checksubmit && !lastName) || validError.lastName ? true : false}
                                                    value={lastName}
                                                    onChange={(e) => { setLastName(e.target.value.toUpperCase()); setValidError({ ...validError, lastName: checkString(e.target.value) || checkSpecialChar(e.target.value) }) }}
                                                    variant="outlined"
                                                    helperText={(checksubmit && !lastName) ? "This field is required" : validError.lastName}
                                                    InputLabelProps={{
                                                        shrink: lastName ? true : false,
                                                    }}
                                                />
                                            </Stack>
                                        </Grid>
                                    </Grid>


                                    <Stack>
                                        <RequiredLabel>User Name</RequiredLabel>
                                        <TextField
                                            className="mb-16"
                                            type="text"
                                            name="userName"
                                            error={(checksubmit && !userName) || validError.userName ? true : false}
                                            value={userName}
                                            onChange={(e) => { setUserName(e.target.value); setValidError({ ...validError, userName: checkBlankSpace(e.target.value) || checkSpecialChar(e.target.value) }) }}
                                            variant="outlined"
                                            onBlur={(e) => checkUniqueUserName(e.target.value)}
                                            helperText={(checksubmit && !userName) ? "This field is required" : validError.userName}
                                            InputLabelProps={{
                                                shrink: userName ? true : false,
                                            }}
                                        />
                                    </Stack>

                                    <Stack className="mb-16">
                                        <RequiredLabel>Select role</RequiredLabel>
                                        <Select name="role"
                                            value={(roleOptions && role) && roleOptions.filter(obj => role.includes(obj.value))}
                                            isMulti
                                            className="select"
                                            onChange={handleRoleChange}
                                            options={roleOptions}
                                            styles={customStyles(((checksubmit && role.length === 0) || validError.role) && "#f44336")}
                                        />
                                        <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && role.length === 0) ? "This field is required" : validError.role}</Typography>
                                    </Stack>
                                    {/* <Stack>
                                        <TextField
                                            className="mb-16"
                                            type="text"
                                            name="designation"
                                            label="Designation"
                                            value={designation}
                                            onChange={(e) => { setDesignation(e.target.value); setValidError({ ...validError, designation: checkString(e.target.value) }) }}
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: designation ? true : false,
                                            }}
                                        />
                                    </Stack> */}
                                </Box>
                            </Grid>
                            <Grid item xs={6}>
                                <Box spacing={2} className="mb-20 mt-20" sx={{ p: 2, border: '1px dashed grey' }}>
                                    <Stack>
                                        <RequiredLabel>Email</RequiredLabel>
                                        <TextField
                                            className="mb-16"
                                            type="text"
                                            name="email"
                                            value={email}
                                            error={(checksubmit && !email) || validError.email ? true : false}
                                            onChange={(e) => { setEmail(e.target.value); setValidError({ ...validError, email: emailValidation(e.target.value) }) }}
                                            onBlur={(e) => checkUniqueEmail(e.target.value)}
                                            helperText={(checksubmit && !email) ? "This field is required" : validError.email}
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: email ? true : false,
                                            }}
                                        />
                                    </Stack>
                                    {!params.id && <><Stack>
                                        <RequiredLabel>Password</RequiredLabel>
                                        <TextField
                                            className="mb-16"
                                            type="password"
                                            name="password"
                                            error={(checksubmit && !password) || validError.password ? true : false}
                                            value={password}
                                            onChange={(e) => { setPassword(e.target.value); setValidError({ ...validError, password: checkPassword(e.target.value) }) }}
                                            variant="outlined"
                                            helperText={(checksubmit && !password) ? "This field is required" : validError.password}
                                            InputLabelProps={{
                                                shrink: password ? true : false,
                                            }}
                                        />
                                    </Stack>
                                        <Stack>
                                            <RequiredLabel>Confirm Password</RequiredLabel>
                                            <TextField
                                                className="mb-16"
                                                type="password"
                                                name="cpassword"
                                                error={(checksubmit && !cpassword) || validError.cpassword ? true : false}
                                                value={cpassword}
                                                helperText={(checksubmit && !cpassword) ? "This field is required" : validError.cpassword}
                                                onChange={(e) => { setCPassword(e.target.value); setValidError({ ...validError, cpassword: comparePassword(e.target.value, password) }) }}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: cpassword ? true : false,
                                                }}
                                            />
                                        </Stack>
                                    </>
                                    }
                                    <Stack>
                                        <label>Select Birthdate</label>
                                        <TextField
                                            className="mb-16"
                                            type="date"
                                            value={birthDate}
                                            name="birthDate"
                                            onChange={(e) => setBirthDate(e.target.value)}
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            sx={{ svg: 'red', input: 'red' }}
                                        />
                                    </Stack>
                                </Box>
                            </Grid>
                        </Grid>



                        <Box className="mb-20 mt-20" sx={{ p: 2, border: '1px dashed grey' }}>

                            <Stack className="mb-16">
                                <RequiredLabel>Select Country</RequiredLabel>
                                <Select name="country"
                                    value={(country && countryOptions) && countryOptions.filter(obj => country.includes(obj.value))}
                                    onChange={handleCountryChange}
                                    isDisabled={(queryParam.get('showroomId') || queryParam.get('customerId')) ? true : false}
                                    options={countryOptions}
                                    styles={customStyles(((checksubmit && !country) || validError.country) && "#f44336")}
                                    className="select"
                                    getOptionLabel={e => (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            {e.icon}
                                            <span style={{ marginLeft: 5 }}>{e.label}</span>
                                        </div>
                                    )}
                                />
                                <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !country) ? "This field is required" : validError.country}</Typography>
                            </Stack>

                            <Stack className="mb-16">
                                <RequiredLabel>Select Partner</RequiredLabel>
                                <Select name="partner"
                                    isDisabled={(queryParam.get('showroomId') || queryParam.get('customerId')) ? true : false}
                                    value={(partner && companyOptions) && companyOptions.filter(obj => partner.includes(obj.value))}
                                    onChange={handlePartnerChange}
                                    styles={customStyles()}
                                    options={companyOptions}
                                    className="select"
                                />
                            </Stack>
                            <Stack className="mb-16">
                                <label>Select Showroom</label>
                                <Select name="showroom"
                                    isMulti
                                    isDisabled={queryParam.get('showroomId') ? true : false}
                                    value={selectedShowrooms}
                                    getOptionValue={(option) => String(option.id)}
                                    onChange={handleShowroomChange}
                                    styles={customStyles()}
                                    options={showroomOptions}
                                    className="select"
                                    isClearable
                                />
                            </Stack>
                            <Stack>
                                <div style={{ color: '#000' }}>
                                    <label>Select Timezone</label>
                                    <TimezoneSelect
                                        value={timezone}
                                        onChange={handleTimeZone}
                                        className="mb-16"
                                        styles={customStyles()}
                                        timezones={{ ...allTimezones }}
                                    />
                                </div>
                            </Stack>
                            <FormGroup>
                                <FormControlLabel control={<Switch checked={active} onChange={handleActiveChange} disabled={params.id && true} />} label="Active" disabled={params.id && true} />
                            </FormGroup>
                            <Grid display={"flex"}>
                                    {profileImageUrl && (<><img
                                        className="w-[50px] h-[50px]"
                                        src={profileImageUrl}
                                        alt={"profile picture"}
                                    />
                                    <Grid className="self-center">
                                        <FuseSvgIcon className=' w-32 h-32 cursor-pointer' onClick={() => removeDocument()}>heroicons-outline:x</FuseSvgIcon>
                                    </Grid></>)}
                                    <Button
                                        // onClick={handleSubmit}
                                        className='h-fit self-center'
                                        variant="contained"
                                        component="label"
                                        color="secondary"
                                        size="small"
                                    >
                                        <input hidden accept="image/*" type="file" ref={fileInputRef}
                                            onChange={(e) => handleChangeUploadProfile(e)}
                                        />
                                        <Typography color="black" >Upload Profile</Typography>
                                    </Button>
                                </Grid>
                        </Box>
                    </div>
                </FormControl>
            </div>

        </div >
    )
}

export default UserForm;
